<template>
  <div class="main-menu-grouping-mobile">
    <menu-item
      ref="mobileGroupingRef"
      :title="activeItem.title"
      :icon="activeItem.icon"
      :decorative-dropdown="false"
      @click="handleOpenMobileMenu"
    ></menu-item>
  </div>
</template>

<script setup lang="ts">
import { useStore } from '@/store';
import helpers from '@/services/helpers';
import MenuItem from '@/components/menu/menu-item.vue';
import { useMainMenuGrouping } from '@/composables';

const store = useStore();
const { activeItem } = useMainMenuGrouping();

const handleOpenMobileMenu = () => {
  store.setMenuGroupingTop(40);
  helpers.afterBrowserRedraw(() => {
    store.setMenuGroupingOpen(!store.mobile.menuGroupingOpen);
  });
};
</script>

<style lang="scss">
.main-menu-grouping-mobile {
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: 0 1px 2px 0 var(--color-black10);

  .menu-list-item {
    background-color: var(--color-white);
    color: var(--color-graphite);
    border-bottom: none;

    &::hover {
      background-color: var(--color-green10);
    }
  }

  .menu-list-item__content:hover {
    color: var(--color-graphite);
  }
}
</style>
